import { render, staticRenderFns } from "./CustomerDataSelection.vue?vue&type=template&id=1c8c23ef&scoped=true&"
import script from "./CustomerDataSelection.vue?vue&type=script&lang=js&"
export * from "./CustomerDataSelection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDataSelection.vue?vue&type=style&index=0&id=1c8c23ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c23ef",
  null
  
)

export default component.exports